// @flow
import * as React from 'react';
import styled from 'styled-components';
import { displayPercent } from 'common/components/Number';

const DemographyPercentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  flex: 1;
  min-width: 0;
  text-align: center;

  h4 {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;

const DemographyPercentRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  ${DemographyPercentWrapper}:not(:last-child) {
    margin-right: 24px;
  }
`;

const DemographyPercentNumber = styled.span`
  color: ${props => props.color};
  font-size: ${props => props.theme.V3.fonts.h3.size}px;

  font-stretch: normal;
  font-style: normal;
  font-weight: ${props => (props.bold ? 'bold' : 'normal')};
  letter-spacing: ${props => props.theme.V3.fonts.h3.letterSpacing}px;
  line-height: normal;

  margin: 0;
`;

interface RowProps {
  children?: DemographyPercent[];
}

function DemographyPercentRow({ children }: RowProps) {
  return (
    <DemographyPercentRowWrapper>
      {children}
    </DemographyPercentRowWrapper>
  );
}

interface Props {
  label: string;
  percent: number;
  bold: boolean;
  color: string;
}

function DemographyPercent({ label, percent, color, bold }: Props) {
  return (
    <DemographyPercentWrapper>
      <h4>{label}</h4>
      <DemographyPercentNumber color={color} bold={bold}>{displayPercent(percent)}</DemographyPercentNumber>
    </DemographyPercentWrapper>
  );
}

DemographyPercent.defaultProps = {
  bold: true,
};

export {
  DemographyPercentRow,
  DemographyPercent,
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/v2/components/demography/DemographyPercentLayout.js